// extracted by mini-css-extract-plugin
export default {"contentListContainer":"I5NW_","title":"_dDxS","subtitle":"_SWJ1","contentList":"meoCM","subtext":"STGRo","link":"LHWtY","listElement":"O53Vv","contentLink":"EsK9s"};